<h1 *ngIf="data.title" mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>

  <div class="alert infBox-warning" role="alert">
    {{data.message}}
  </div>

  <p class="fs-4 fw-bold">{{data.notes[0]}}</p>

  <p style="font-style: italic;">{{data.notes[1]}}</p>

  <div *ngIf="!data.options.length" class="row">
    <div class="col-12">
      <button class="btn btn-block">
        {{data.closeButton}}
      </button>
    </div>
  </div>

  <div *ngIf="!data.options.length" class="row">
    <div class="col-12">
      <button class="btn btn-block">
        {{data.closeButton}}
      </button>
    </div>
  </div>

  <div *ngIf="data.options.length === 1" class="row">
    <div class="col-12">
      <button class="btn btn-block" [mat-dialog-close]="data.options[0]">
        {{data.options[0]}}
      </button>
    </div>
  </div>

  <div *ngIf="data.options.length > 1 && !residuo" class="row">
    <div *ngFor="let option of data.options" class="col-6">
      <button class="btn btn-block" [mat-dialog-close]="option">
        {{option}}
      </button>
    </div>
  </div>

  <div *ngIf="data.options.length > 1 && residuo" class="row">
    <div *ngFor="let option of data.options" class="col-4">
      <button class="btn btn-block" [mat-dialog-close]="option">
        {{option}}
      </button>
    </div>
  </div>
</div>
<!-- <div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">No Thanks</button>
  <button mat-button [mat-dialog-close]="data.animal" cdkFocusInitial>Ok</button>
</div> -->
